
define(
  'MachineLookUp',
  [
    'Home.View',
    'MachineLookUp.View',
    'underscore'
  ],
  function (
    HomeView,
    MachineLookUpView,
    _
  ) {
    'use strict';

    return {
      mountToApp: function mountToApp(container) {
        var layout = container.getComponent('Layout');

        if (layout) {
          layout.registerView('MachineLookUpView', function() {
            return new MachineLookUpView({ application: container });
          });
        }
      }
    };
  }
);
